import styled from 'styled-components';
import { theme } from 'consts/theme';

export const StyledHeaderTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  color: ${theme.colors.white};
  font-size: 17px;
  font-weight: 600;
  height: 30px;
  width: 80%;
  min-width: 220px;
  max-width: 250px;
  text-align: center;
  text-transform: uppercase;
  overflow: hidden;
  .title-animated {
    white-space: nowrap;
    text-overflow: ellipsis;
    animation: ticker 15s infinite linear forwards;
    animation-iteration-count: infinite;
    -webkit-animation: ticker 15s infinite linear forwards;
    -webkit-animation-iteration-count: infinite;
    @keyframes ticker {
      0% {
        transform: translate(60%, 0);
      }

      50% {
        transform: translate(0, 0);
      }

      100% {
        transform: translate(-60%, 0);
      }
    }
  }
`;
